import React, { useEffect, useState } from "react";
import { Footer, Navbar } from "../components";
import axios from "axios";
import configData from "../config.json";

const AboutPage = () => {
    const [branches,setBranches]=useState([]);
   

    useEffect(() => {
        const getBranches = async () => {
        const response=await axios.get(configData.SERVER_URL+'/enterprises')
          setBranches(response.data);
        };
        getBranches();
    }, []);

  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center" style={{color:"green"}}>About Us</h1>
        <hr />
        <p className="lead text-justify">
        Bangladesh Steel & Engineering Corporation (BSEC) was formed on 1st July 1976 by amalgamating 
        (1) Bangladesh Steel Mills Corporation and (2) Bangladesh Engineering & Shipbuilding Corporation 
        under Bangladesh Industrial Enterprises. Nationalization (2nd Amendment) Ordinance, 1976. 
        The Corporation primarily started with 62 (sixty-two) enterprises. 
        Out of them 8(eight) are currently in operation and Dhaka Steel Works Ltd started again under 
        trial production basis in January 2018 after a long break. Amongst them 1) Atlas Bangladesh Ltd 
        2) National Tubes Ltd 3) Eastern Cables Ltd. have been off-loaded for 49% shares to the general public 
        and employees of these three companies. 
        Enterprises under BSEC have been playing an important role in the economic development of the country 
        as they are producing electric cables, transformers, tube lights, CFL bulbs, super enamelled copper wire, 
        MS/GI/API Pipe etc. BSEC is also contributing to road transport sector by assembling bus, truck, jeep, 
        double cabin pickup motorcycles etc.
        </p>

        <h2 className="text-center py-4" style={{color:"green"}}>Our Enterprises</h2>
        <hr />
        <div className='row'>
        {               
                branches && branches.length>0 && branches.map((i)=>
                <div className="row text-center" key={i.id}>
                    <div className="col-lg-3 col-md-3 col-sm-3 col-xs-6">
                        <img src={configData.IMAGE_URL+'/companies/'+i.logo} style={{width:'75px'}} ></img>
                        <h6 style={{color: "green"}}>{i.branchName}</h6>
                        <h6 style={{color: "red"}}>{i.hotlineNo}</h6>
                        <h6>{i.webaddress}</h6>
                    </div>
                    <div className="col-lg-9 col-md-9 col-sm-9 col-xs-12 text-justify">{i.description}</div>
                    <hr/>
                </div>
                )
          }
        </div>

        

      </div>
      <Footer />
    </>
  )
}

export default AboutPage